var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedReceive ? '编辑' : '新增'}收款账号`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "收款账号",
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请填写收款账号"
    },
    model: {
      value: _vm.formItem.account,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "account", $$v);
      },
      expression: "formItem.account"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "行号",
      "prop": "bankNo"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请填写行号"
    },
    model: {
      value: _vm.formItem.bankNo,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "bankNo", $$v);
      },
      expression: "formItem.bankNo"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "账号简称",
      "prop": "abbr"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请填写账号简称"
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "账号银行",
      "prop": "bank"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请填写银行"
    },
    model: {
      value: _vm.formItem.bank,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "bank", $$v);
      },
      expression: "formItem.bank"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "公司",
      "prop": "company"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "回款类型",
      "prop": "type"
    }
  }, [_c('CheckboxGroup', {
    model: {
      value: _vm.formItem.type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "type", $$v);
      },
      expression: "formItem.type"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "trans"
    }
  }, [_vm._v("银行转账")]), _c('Checkbox', {
    attrs: {
      "label": "bankAccBill"
    }
  }, [_vm._v("银承")]), _c('Checkbox', {
    attrs: {
      "label": "commAccBill"
    }
  }, [_vm._v("商承")]), _c('Checkbox', {
    attrs: {
      "label": "bankAccBillPaper"
    }
  }, [_vm._v("纸质银承")]), _c('Checkbox', {
    attrs: {
      "label": "check"
    }
  }, [_vm._v("支票")]), _c('Checkbox', {
    attrs: {
      "label": "cash"
    }
  }, [_vm._v("现金钞票")]), _c('Checkbox', {
    attrs: {
      "label": "yun"
    }
  }, [_vm._v("云信通")]), _c('Checkbox', {
    attrs: {
      "label": "jian"
    }
  }, [_vm._v("建信融通")])], 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "账号状态",
      "prop": "active"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.formItem.radio,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "radio", $$v);
      },
      expression: "formItem.radio"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "true"
    }
  }, [_c('span', [_vm._v("正常")])]), _c('Radio', {
    attrs: {
      "label": "false"
    }
  }, [_c('span', [_vm._v("停用")])])], 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "输入备注..."
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }